import { getExamDistributionTitle, MONTH_ORDER } from '@exam-center/exam-distribution-management';
import { type ExamEventsCountByMonth } from '@exam-center/graphql';
import { type TableCellProps } from '@shared/components';
import type { TableBodyRow } from '@shared/table-generator';

function getExamEventCountByExamCenterCodeCells(
  examCenterCodes: string[],
  examEventCountByExamCenterCode?: Record<string, number>,
) {
  return examCenterCodes.map<TableCellProps>((examCenterCode) => ({
    id: examCenterCode,
    children: examEventCountByExamCenterCode?.[examCenterCode]?.toString() ?? '-',
    sx: {
      minWidth: '100px',
    },
    align: 'center',
  }));
}

export function generateRows(
  year: string,
  examCenterCodes: string[],
  examCenterRoundData: ExamEventsCountByMonth[],
) {
  const rows = MONTH_ORDER.map<TableBodyRow>((monthAbbr, order) => {
    const examEventCountData = examCenterRoundData.find((item) => item.month === order);
    return {
      'data-month-abbr': monthAbbr,
      children: [
        { id: 'no', children: order + 1, align: 'center' },
        {
          id: 'period',
          children: getExamDistributionTitle(parseInt(year), monthAbbr),
          sx: (theme) => ({
            fontWeight: theme.typography.body1Semibold,
            minWidth: '244px',
          }),
        },
        ...getExamEventCountByExamCenterCodeCells(
          examCenterCodes,
          examEventCountData?.examEventsCountByExamCenterCode,
        ),
      ],
    };
  });

  return rows;
}
